import { Button, Tooltip } from '@cian/ui-kit';
import * as React from 'react';

import {
  ADD_TO_COMPARE_LABEL,
  ADD_TO_COMPARE_TOOLTIP,
  COMPARE_BUTTON_DATA_MARK,
  REMOVE_FROM_COMPARE_LABEL,
  REMOVE_FROM_COMPARE_TOOLTIP,
} from './constants';
import { IconActionCompareAdd16, IconActionCompareAdded16 } from '@cian/ui-kit-design-tokens/icons';

interface ICompareButtonWithTooltipProps {
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonWithTooltip({ isAdded, onClick }: ICompareButtonWithTooltipProps) {
  return (
    <Tooltip placement="bottom" title={isAdded ? REMOVE_FROM_COMPARE_TOOLTIP : ADD_TO_COMPARE_TOOLTIP}>
      <Button
        beforeIcon={
          isAdded ? (
            <IconActionCompareAdded16 color="icon-main-default" />
          ) : (
            <IconActionCompareAdd16 color="icon-main-default" />
          )
        }
        theme="stroke_primary"
        size="M"
        onClick={onClick}
        data-mark={COMPARE_BUTTON_DATA_MARK}
        data-testid="NewbuildingHeaderCompareButton"
        aria-label={isAdded ? REMOVE_FROM_COMPARE_LABEL : ADD_TO_COMPARE_LABEL}
      />
    </Tooltip>
  );
}
